<template>
  <DefaultPage>
    <div class="analytics-header">
      <h1 class="page-title">Analytics</h1>
      <div class="category-select-wrapper">
        <select v-model="activeCategory" class="category-select">
          <option value="ba">Lägenhetsbyten</option>
          <option value="ah">Andrahand</option>
          <option value="ovPrivate">Överlåtelser privat</option>
          <option value="ovCompany">Överlåtelser företag</option>
        </select>
      </div>
    </div>
    <div class="content">
      <AnalyticsDashboard :category="activeCategory" />
    </div>
  </DefaultPage>
</template>

<script>
import DefaultPage from '@/components/DefaultPage.vue';
import AnalyticsDashboard from '@/components/AnalyticsDashboard.vue';

export default {
  components: {
    DefaultPage,
    AnalyticsDashboard
  },
  data() {
    return {
      activeCategory: 'ba'
    };
  }
};
</script>

<style scoped>
.analytics-header {
  display: flex;
  align-items: center;
  gap: 1.6rem;
  margin: 3.2rem 3.2rem 3.2rem 4rem;
}

.page-title {
  color: var(--color-dark-blue);
  font-size: 3.2rem;
  margin: 0;
}

.category-select-wrapper {
  position: relative;
}

.category-select {
  font-family: var(--font-averta);
  font-size: 1.4rem;
  font-weight: 600;
  color: var(--color-dark-blue);
  background: #fff;
  border: 1px solid #d0d1d8;
  border-radius: 8px;
  padding: 0.5rem 2.5rem 0.5rem 1rem;
  appearance: none;
  cursor: pointer;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23878b9d' stroke-width='2' fill='none'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.8rem center;
}

.content {
  margin-left: 4rem;
  max-width: 100%;
  width: 1400px;
  padding-bottom: 20rem;
}
</style>
